import { getOrderPayments } from './get-order-payments';
export const getOrderPaymentById = (id) => { var _a; return (_a = getOrderPayments()) === null || _a === void 0 ? void 0 : _a.find(p => p.id === id); };
